import Variables from '../Variables.json';

export const sendOrderEmail = async (orderData) => {
    try {
        console.log("Sending order email with data:", orderData);

        // Construct the Ticket1 JSON string
        // The API expects Ticket1 to be a JSON string of an array of objects
        // Example: "[{'FarmerName':'Vishnu','OrderID':'YK260101001',...}]" 
        // Note: The curl example uses single quotes inside the string, but standard JSON uses double quotes. 
        // We will standard JSON serialization which should be compatible if the backend parses standard JSON.
        // If the backend specifically requires single quotes inside the string, we might need a custom stringifier, 
        // but typically JSON.stringify is sufficient for web APIs.

        const ticket1Value = JSON.stringify(orderData);

        const formData = new FormData();
        formData.append('Ticket1', ticket1Value);

        const response = await fetch(`${Variables.baseUrl}/api/Products/SendOrderMailToAdmin`, {
            method: 'POST',
            body: formData
        });

        const result = await response.json();
        console.log("Order email sent response:", result);
        return result;
    } catch (error) {
        console.error("Error sending order email:", error);
        // We generally don't want to break the flow if email fails, so we just log it
        return null;
    }
};
